import AutocompleteController from "./autocomplete_controller"

export default class AutocompleteTextFieldController extends AutocompleteController {
  static targets = [
    ...AutocompleteController.targets,
    "item",
    "textFieldHiddenInput",
    "textFieldLabel",
  ]

  displayTextFieldValue() {
    const value = this.inputTarget.value

    if (!value) {
      return
    }

    this.textFieldHiddenInputTarget.value = value
    this.itemTarget.setAttribute("data-value", value)
    this.textFieldLabelTarget.innerHTML = value

    this.suggestionsWrapperTarget.classList.remove("hidden")
    this.suggestionsTarget.classList.remove("hidden")
  }
}
